import WINDOW from "./window";

const setWindowData = () => {
  WINDOW.set("height", document.documentElement.clientHeight);
  WINDOW.set("width", document.documentElement.clientWidth);
  WINDOW.set("document-height", document.documentElement.scrollHeight);
  WINDOW.set("document-width", document.documentElement.scrollWidth);
};

export default setWindowData;
